import ServiceStore from "stores/ServiceStore";
import type DashboardStore from "./DashboardStore";
import { RouteType } from "types/RouteType";

const dashboardRoute: RouteType[] = [
  {
    name: "Home",
    path: "/home",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Dashboard",
        enableRefreshButton: true,
        component: () => import("./Dashboard.Header"),
      },
      body: {
        component: () => import("./Dashboard.Body"),
        grayBackground: true,
      },
    },
    group: "Administration",
    requiresAuth: false,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Keep the accounts sidebar hydrated.
      const accountsStore = rootStore?.accountsStore as ServiceStore;
      if (accountsStore) accountsStore.find();

      // Plant-wide widgets ask the dashboard store to refresh the rest.
      const dashboardStore = (
        rootStore as { dashboardStore?: DashboardStore }
      ).dashboardStore;
      if (dashboardStore) void dashboardStore.refreshHomepageData();
    },
    dialogs: [
      {
        name: "AccountsListDialog",
        component: () => import("./Home.Body.AccountsSummaryList"),
        title: "Accounts List",
        cancelButton: true,
        height: 600,
      },
    ],
  },
];

export default dashboardRoute;
